import { Button, Flex, Icon, Text } from '@chakra-ui/react';
import Card from 'components/card/Card';
import React from 'react';
import resguardosApi from 'api/resguardos';
import { MdDownload, MdPrint, MdShare } from 'react-icons/md';
import Content from 'views/admin/main/ecommerce/orderDetails/components/Content';

type ComponentToPrintProps = {
  bgButton: string;
  bgFocus: any;
  bgHover: any;
  handlePrint?: () => void;
  [x: string]: any;
};

type ComponentToPrintState = {
  ultimoId: number | null;
};

const getFechaActual = () => {
  const fecha = new Date();
  const opciones: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZone: 'America/Mexico_City'
  };
  return fecha.toLocaleDateString('es-MX', opciones);
}

export default class ComponentToPrint extends React.Component<ComponentToPrintProps, ComponentToPrintState> {
  constructor(props: ComponentToPrintProps) {
    super(props);
    this.state = {
      ultimoId: null,
    };
  }

  async componentDidMount() {
    // Supongo que resguardosApi.listado es una función async que retorna Promise con el listado
    try {
      const listado = await resguardosApi.listado(); // ¡Llamar a la función para obtener los datos!
      console.log('Listado de resguardos:', listado);
      
        const ultimoResguardo = listado.length
        this.setState({ ultimoId: ultimoResguardo });
      
    } catch (error) {
      console.error('Error al obtener el listado de resguardos:', error);
    }
  }
  

  render() {
    const { bgButton, bgFocus, bgHover, ...rest } = this.props;
    const { ultimoId } = this.state;

    return (
      <Card
        {...rest}
        justifySelf="center"
        alignSelf="center"
        m="10px"
        my="0px"
        p="16px"
      >
        <Card
          bgGradient="linear(to-b, brand.400, brand.600)"
          backgroundRepeat="no-repeat"
          bgSize="cover"
          bgPosition="10%"
          flexDirection="row"
          p={{ base: '16px', md: '32px' }}
          py="20px"
          borderRadius="20px"
        >
          <Flex direction="column" color="white" h="100%" w="100%">
            <Text
              lineHeight="100%"
              fontSize={{ sm: 'md', md: '24px', lg: '28px', xl: '32px' }}
              fontWeight="bold"
            >
              {ultimoId ? `Resguardo #${ultimoId}` : 'Resguardo'}
            </Text>
            <Text fontSize={{ base: 'sm', md: 'md' }} fontWeight="regular">
              {getFechaActual()}
            </Text>
          </Flex>
          <Flex alignSelf="start" my={{ base: 'auto', md: '0px' }}>
            <Button
              onClick={() => this.props.handlePrint && this.props.handlePrint()}
              ms="auto"
              me="10px"
              alignItems="center"
              justifyContent="center"
              bg={bgButton}
              _hover={bgHover}
              _focus={bgFocus}
              _active={bgFocus}
              p="6px"
              minW="unset"
              h="28px"
              lineHeight="100%"
              borderRadius="10px"
            >
              <Icon as={MdPrint} color="white" w="16px" h="16px" />
            </Button>
            <Button
              alignItems="center"
              me="10px"
              justifyContent="center"
              bg={bgButton}
              _hover={bgHover}
              _focus={bgFocus}
              _active={bgFocus}
              p="6px"
              minW="unset"
              h="28px"
              lineHeight="100%"
              borderRadius="10px"
            >
              <Icon as={MdDownload} color="white" w="16px" h="16px" />
            </Button>
            <Button
              alignItems="center"
              justifyContent="center"
              bg="linear-gradient(293.45deg, #FA709A 0%, #FEE140 92.27%)"
              _hover={{ bg: 'linear-gradient(293.45deg, #FA709A 0%, #FEE140 92.27%)' }}
              _focus={{ bg: 'linear-gradient(293.45deg, #FA709A 0%, #FEE140 92.27%)' }}
              _active={{ bg: 'linear-gradient(293.45deg, #FA709A 0%, #FEE140 92.27%)' }}
              p="6px"
              minW="unset"
              h="28px"
              lineHeight="100%"
              borderRadius="10px"
            >
              <Icon as={MdShare} color="white" w="16px" h="16px" />
            </Button>
          </Flex>
        </Card>
        <Content tableData={[]} />
      </Card>
    );
  }
}
